module.exports = __webpack_public_path__ + "d00e06d323cf9c5b576193d01066f89e.png";